import degreeToRadian from "common/utils/degreeToRadian";
import type { Matrix3 } from "three";
import { Color, Vector2, Vector3, Vector4 } from "three";
import type { UVTransformParams } from "./designMaterialTypes";

export const bUniform = (value: boolean) => ({ value });
export const fUniform = (value: number) => ({ value });
export const iUniform = (value: number) => ({ value });
export const colorUniform = (value: string) => ({ value: new Color(value) });
export const v2Uniform = (x: number, y: number) => ({ value: new Vector2(x, y) });
export const v3Uniform = (x: number, y: number, z: number) => ({ value: new Vector3(x, y, z) });
export const v4Uniform = (x: number, y: number, z: number, u: number) => ({ value: new Vector4(x, y, z, u) });
export const fArrayUniform = (value: number[]) => ({ value });

export function initUVMatrixFromParams(params: UVTransformParams, uvMat: Matrix3) {
  uvMat.setUvTransform(
    params.translateU / params.scaleU,
    params.translateV / params.scaleV,
    1 / params.scaleU,
    1 / params.scaleV,
    degreeToRadian(params.rotate),
    0,
    0,
  );
}
